import { TableColumnType, TableComponent, Heading } from "@tutellus/tutellus-components"
import { useTranslation } from "react-i18next"
import { useLayout } from "../../../context"
import { ProjectConfig } from "../../../domain/project/Models/ProjectConfig"
import { UserBalancesSerialized } from "../../../domain/user/Models/UserBalances"
import { useFormatAmounts } from "../../../hooks/useFormatAmounts"
import { TokenAddressCell } from "../../TableCells/TokenAddressCell"

type WalletTokensTableProps = { userBalances: UserBalancesSerialized; projectConfig: ProjectConfig }

export const WalletTokensTable = ({ userBalances, projectConfig }: WalletTokensTableProps) => {
  const { t } = useTranslation("wallet")
  const { currencyID } = useLayout()
  const { formatCurrencyAmounts, formatAmount } = useFormatAmounts()

  const erc20Balances = userBalances?.balances.filter((balance) => {
    const tokenConfig = projectConfig.tokens.find((token) => token.id === balance.tokenID)
    const currencyAmount = balance.currencyAmounts?.find((c) => c.currencyID === currencyID)?.number || 0
    return tokenConfig?.type === "ERC20" && currencyAmount > 0 // Excluir balances de 0
  })

  const columns: TableColumnType<UserBalancesSerialized["balances"][0]>[] = [
    { key: "tokenID", header: t("token"), content: ({ tokenID }) => <TokenAddressCell tokenID={tokenID} /> },
    { key: "number", header: t("quantity"), content: ({ number }) => formatAmount(number), align: "right" },
    {
      key: "currencyAmounts",
      header: t("value"),
      content: ({ currencyAmounts }) => formatCurrencyAmounts(currencyAmounts),
      sortValue: ({ currencyAmounts }) => currencyAmounts?.find((c) => c.currencyID === currencyID)?.number || 0,
      align: "right",
    },
  ]

  return (
    <>
      <Heading align="center">{t("tokens")}</Heading>
      <TableComponent columns={columns} data={erc20Balances} defaultSort={{ key: "number", direction: "desc" }} />
    </>
  )
}
